import React, { useEffect } from 'react';
// Include the document path: <base href="/"> otherwise resolves fragments to home.
export function blogSectionHref(id, pagePath = window.location.pathname + window.location.search) {
  return pagePath.split('#')[0] + '#' + encodeURIComponent(id);
}
export function safeLink(url) { try { const parsed = new URL(url); return ['https:', 'http:'].includes(parsed.protocol) && !parsed.username && !parsed.password ? url : null; } catch { return null; } }
function inline(text) {
  return text.split(/(\*\*[^*]+\*\*|\[[^\]]+\]\([^)]+\))/g).map((part,i) => {
    if(part.startsWith('**') && part.endsWith('**')) return <strong key={i}>{part.slice(2,-2)}</strong>;
    const link=part.match(/^\[([^\]]+)\]\(([^)]+)\)$/);
    if(link && safeLink(link[2]))return <a key={i} href={link[2]} target="_blank" rel="noopener noreferrer">{link[1]}</a>;
    return part;
  });
}
export function contentSections(content = '') {
  let hasSection = false;
  let index = 0;
  return content.replace(/\r\n/g, '\n').split(/\n\s*\n/).filter(Boolean).flatMap(paragraph => {
    const groups = [];
    paragraph.split('\n').forEach(line => {
      const heading = line.match(/^(#{1,3})\s+(.+)$/);
      if (heading) {
        const level = heading[1].length < 3 || !hasSection ? 2 : 3;
        if (level === 2) hasSection = true;
        groups.push({ text: line, heading: heading[2], level, id: 'blog-section-' + (++index) });
      } else if (groups.length && !groups[groups.length - 1].heading) {
        groups[groups.length - 1].text += '\n' + line;
      } else groups.push({ text: line });
    });
    return groups;
  });
}
export default function BlogContent({ content = '', showContents = false, pagePath }) {
  const blocks = contentSections(content);
  useEffect(() => {
    if (!showContents || !window.location.hash.startsWith('#blog-section-')) return;
    // Article content arrives asynchronously; restore a bookmarked section after it renders.
    const id = window.location.hash.slice(1);
    document.getElementById(id)?.scrollIntoView?.();
  }, [content, showContents, pagePath]);
  const headings = blocks.filter(block => block.heading);
  return <>{showContents && headings.length >= 3 && <nav className="blog-toc" aria-label="Índice del artículo"><h2>En este artículo</h2><ol>{headings.map(heading => <li key={heading.id} className={heading.level === 3 ? 'blog-toc-subsection' : ''}><a href={blogSectionHref(heading.id, pagePath)}>{heading.heading.replace(/\*\*/g, '')}</a></li>)}</ol></nav>}
  <div className="blog-prose">{blocks.map((section,i)=> {
    const block = section.text;
    const image=block.match(/^!\[([^\]]+)\]\(([^)]+)\)$/);
    if(image && safeLink(image[2]))return <figure key={i} style={{margin:'28px 0'}}><img src={image[2]} alt={image[1]} loading="lazy" style={{width:'100%',height:'auto',borderRadius:12}}/>{image[1]&&<figcaption style={{fontSize:14,color:'#64748b'}}>{image[1]}</figcaption>}</figure>;
    if(section.heading){const Tag='h'+section.level;return <Tag key={i} id={section.id}>{inline(section.heading)}</Tag>;}
    const lines=block.split('\n');
    if(lines.every(l=>/^[-*] /.test(l)))return <ul key={i}>{lines.map((l,j)=><li key={j}>{inline(l.slice(2))}</li>)}</ul>;
    if(lines.every(l=>/^\d+\. /.test(l)))return <ol key={i}>{lines.map((l,j)=><li key={j}>{inline(l.replace(/^\d+\. /,''))}</li>)}</ol>;
    if(block.startsWith('> '))return <blockquote key={i}>{inline(block.replace(/^> /gm,''))}</blockquote>;
    return <p key={i}>{lines.map((l,j)=><React.Fragment key={j}>{j>0 && <br/>}{inline(l)}</React.Fragment>)}</p>;
  })}</div></>;
}
